<template>
  <div>
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("account.confirmOrder") }}
    </h1>

    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("account.confirmOrder") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="custom_page_content">
      <div class="container">
        <ul class="media-list">
          <li class="media">
            <div class="media-left">
              <img class="media-object" :src="info.cover" :alt="info.productName" />
            </div>
            <div class="media-body">
              <h4 class="media-heading text-overflow">{{ info.productName }}</h4>
              <div class="row margint20">
                <div class="col-xs-12 col-sm-8">
                  <div v-html="info.productDescribe"></div>
                  <template v-if="info.parameters&&info.parameters.filter(item=>parameterId.includes(item.id+'')).length">
                    <br/>
                    <div v-for="(item, i) in info.parameters.filter(item=>parameterId.includes(item.id+''))" :key="i">
                      <label style="font-weight: 400">
                         - {{item.parameterName}}
                        <span style="margin-left: 20px;font-weight: 400;">Price({{info.currency}}): {{item.parameterPrice}}</span>
                      </label>
                    </div>
                  </template>
                </div>
                <div class="col-xs-4 col-sm-2">X{{ number }}</div>
                <div class="col-xs-4 col-sm-2">{{info.totalPrice}}({{info.currency}})</div>
              </div>
            </div>
          </li>
        </ul>
        <div>
          <div class="row">
            <div class="col-xs-12 col-sm-6"></div>
            <div class="col-xs-12 col-sm-6"><textarea v-model="address" class="form-control" rows="3" :placeholder="$t('account.address')+''" /></div>
          </div>
        </div>
        <div class="page-footer">
          <div class="row">
            <div class="col-xs-12 col-sm-6" style="margin: 10px 0;">
              <textarea v-model="remarks" class="form-control" rows="2" :placeholder="$t('account.remarks')+''" />
            </div>
            <div class="col-xs-12 col-sm-6" style="display: flex;align-items: center;justify-content: flex-end;padding-top: 18px;">
              <span>{{ $t("account.postage") }}({{info.currency}})：<strong>{{info.postage}}</strong></span>
              <span>{{ $t("account.total") }}({{info.currency}})：<strong>{{total}}</strong></span>
              <button @click="toPay" :disabled="loading" type="button" class="btn btn-primary btn-lg">{{ $t("account.toPay") }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { watch, onMounted, ref, computed } from "vue"
import i18n from "@/i18n"
import axios from "axios"
import { payment, subIndependentOrder, getProductInfo } from "@/utils/api"
import router from "@/router"

const id = ref(router.currentRoute.query.id)
const number = ref(router.currentRoute.query.number)
const parameterId = ref(router.currentRoute.query.parameterId?router.currentRoute.query.parameterId.split(','):[])
const info = ref({})
const address = ref("")
const remarks = ref("")
const loading = ref(false)

const total = computed(() => {
  const t = info.value.parameters && info.value.parameters.filter(item => parameterId.value.includes(item.id+'')).reduce((acc, cur)=>acc+Number(cur.parameterPrice),0)
  return (number.value * (Number(info.value.productPrice) + t) + info.value.postage)||0
})

const toPay = async () => {
  if(!address.value) {layer.msg(i18n.t('account.inputAddress')); return;}
  loading.value = true
  const orderInfo = await subIndependentOrder({ parameterId: parameterId.value.join(','), address: address.value,remarks:remarks.value,productId: info.value.id, productNum: number.value })
  if (orderInfo.code == "-500") {
    layer.msg("order not found!")
    loading.value = false
    return
  }
  await payment({ orderNo: orderInfo.data.orderNo, cancelUrl: window.location.origin + "/OrderList", successUrl: window.location.origin + "/OrderList", money: 100 }).then((res) => {
    window.location.href = res.data
  })
}

const getList = () => {
  getProductInfo({ id: id.value }).then((res) => {
    res.data.totalPrice = +res.data.productPrice + Number(res.data.parameters && res.data.parameters.filter(item => parameterId.value.includes(item.id+'')).reduce((acc, cur)=>acc+Number(cur.parameterPrice),0))
    info.value = res.data
  })
}

onMounted(() => {
  getList()
})
</script>

<style scoped>
.page-footer {
  /* display: flex;
  justify-content: flex-end; */
  padding: 20px;
  border-top: 1px solid #f1f2f3;
  margin-top: 20px;
}
.page-footer span {
  display: flex;
  align-items: center;
  margin-right: 20px;
  font-size: 22px;
}
.page-footer span strong {
  color: #e7141a;
}
.media-object {
  max-width: initial;
  width: 204px;
  height: 204px;
}
.custom_page_content {
  min-height: 50vh;
}
.custom_page_content ol,
.custom_page_content ul {
  padding-left: 0;
}
.media-heading {
  line-height: 24px;
}
</style>
